import { isEmpty } from '@jjj/components';
import { t } from '../../../../i18n';
import { keyBy } from '../../../../helpers/core';
import { createReducer } from '../../../../helpers/reducer';
import actions from './actions';

const initState = {
  superannuation: null,
  abnSuggestions: [],
  superfundSuggestions: [],
  submitLoading: false,
  editForm: {},
  formInfo: {},
  baseError: null,
  loading: false,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'account_name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.applicants.superannuation.name_of_account_label'),
      });
    }
  }

  if (attr === 'abn') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.applicants.superannuation.fund_abn_label'),
      });
    }
  }

  if (attr === 'usi') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.applicants.superannuation.fund_spin_usi_label'),
      });
    }
  }

  if (attr === 'name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.applicants.superannuation.institution_label'),
      });
    }
  }

  if (attr === 'superfund_member_number') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.applicants.superannuation.account_number_label'),
      });
    }
  }

  return error;
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { superannuation } = payload;

  return {
    ...state,
    superannuation,
    loading: false,
  };
}

function onSave(state) {
  return {
    ...state,
    submitLoading: true,
  };
}

function onSaveSuccess(state) {
  return {
    ...state,
    editForm: {},
    submitLoading: false,
  };
}

function onEdit(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadAbnSuggestionsSuccess(state, { payload: abnSuggestions }) {
  return { ...state, abnSuggestions };
}

function onLoadSuperfundSuggestionsSuccess(state, { payload: superfundSuggestions }) {
  return { ...state, superfundSuggestions };
}

function onEditSuccess(state, { payload }) {
  const { formInfo, superannuation } = payload;
  const propsArray = Object.keys(superannuation);

  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value:
        superannuation[prop] && Object.prototype.hasOwnProperty.call(superannuation[prop], 'id')
          ? superannuation[prop].id
          : superannuation[prop],
      error: validate(prop, superannuation[prop], state),
      touched: false,
    }),
  );

  return {
    ...state,
    loading: false,
    editForm,
    formInfo,
  };
}

function onCancel(state) {
  return { ...state, editForm: {} };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;
  const baseError = data.superfund ? data.superfund[0] : null;

  return {
    ...state,
    submitLoading: false,
    baseError,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.EDIT]: onEdit,
  [actions.EDIT_SUCCESS]: onEditSuccess,
  [actions.SAVE]: onSave,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.LOAD_ABN_SUGGESTIONS_SUCCESS]: onLoadAbnSuggestionsSuccess,
  [actions.LOAD_SUPERFUN_SUGGESTIONS_SUCCESS]: onLoadSuperfundSuggestionsSuccess,
  [actions.CANCEL]: onCancel,
  [actions.TOUCH]: onTouch,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.CLEAR_STORE]: onClearStore,
});
